import PropTypes from 'prop-types';
import { createRef, useEffect, useState } from 'react';
import './index.scss';

const DropdownModal = (
    {
        children,
        classNameForEvent,
        customClass,
        customStyleInline,
        onModalClose,
        overrideDropdown,
        ...rest
    },
) => {
    const node = createRef();
    const [isVisible, setIsVisible] = useState(rest.isVisible ?? false);

    useEffect(() => {
        setIsVisible(rest.isVisible ?? false);
    }, [rest.isVisible]);

    const handleClick = () => {
        if (onModalClose) {
            onModalClose();
        }
    };

    const handleOutsideClick = (e) => {
        // ignore clicks on the modal component itself
        const path = e.path || (e.composedPath && e.composedPath());
        const res = path && classNameForEvent
            ? path.find(x => x.className === classNameForEvent || x.id === classNameForEvent)
            : false;

        if (((node.current?.contains(e.target)) || overrideDropdown) || res) {
            return;
        }
        handleClick();
    };

    useEffect(() => {
        if (isVisible) {
            // attach/remove event handler
            document.addEventListener('click', handleOutsideClick, false);
        } else {
            document.removeEventListener('click', handleOutsideClick, false);
        }

        return function cleanup() {
            document.removeEventListener('click', handleOutsideClick, false);
        };
    }, [isVisible, handleOutsideClick]);

    return (
        <div
            ref={node}
            id="dropdown-modal"
            className={`signature__dropdown-modal ${isVisible ? '' : 'hidden'} ${customClass}`}
            style={customStyleInline}
        >
            {
                children
            }
        </div>
    );
};

DropdownModal.propTypes = {
    customClass: PropTypes.string,
    classNameForEvent: PropTypes.string,
    isVisible: PropTypes.bool,
    customStyleInline: PropTypes.object,
    onModalClose: PropTypes.func,
    overrideDropdown: PropTypes.bool,
};

export default DropdownModal;
